module.exports = __webpack_public_path__ + "img/ring_r_s_0_null@3x.eeee1e3e.png";